function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M141.7 283.5L0 141.7 141.7 0l141.7 141.7-141.7 141.8zM40.1 141.7l101.7 101.7 101.7-101.7L141.7 40.1 40.1 141.7z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M126.1 184.6l28.8-28.8H75.2v-28h79.7L126.1 99l19.8-19.6 62.3 62.3-62.3 62.3-19.8-19.4z"
})));